import { useEffect, useState } from 'react'

// Context
import { useLayoutContext } from '../../../../../contexts/LayoutContext'
import { useProfileContext } from '../../../../../contexts/ProfileContext'

// Components
import LayoutItem from './components/LayoutItem'

// Styles
import style from './syle.module.css'

const ProfileLayout = ({ editMode, toggleModal, openModal }) => {
  const [rows, setRows] = useState([])
  const [draggingIndex, setDraggingIndex] = useState(null)
  const [dragOverIndex, setDragOverIndex] = useState(null)

  const { layout, setLayout, saveLayout } = useLayoutContext()
  const { userProfile } = useProfileContext()

  useEffect(() => {
    const newRows = []
    let index = 0

    while (index < layout.length) {
      const current = layout[index]

      if (current.type === 'half') {
        const next = layout[index + 1]
        const isNextHalf = next?.type === 'half'

        if (isNextHalf) {
          if (editMode) {
            newRows.push(
              <span
                key={`add-after-half-${index}`}
                className={`${style.addComponentButton} ${style.addComponentButton_horizontal}`}
              >
                +
              </span>
            )
          }

          newRows.push(
            <div
              key={`half-row-${index}`}
              className={`${style.twoColumnWrapper} ${
                editMode && style.twoColumnWrapper_editMode
              }`}
            >
              {[current, next].map((item, j) => {
                const nextIndex = index + j
                return (
                  <LayoutItem
                    key={nextIndex}
                    handleDragStart={handleDragStart}
                    handleDragOver={handleDragOver}
                    handleDrop={handleDrop}
                    handleDragEnd={handleDragEnd}
                    draggingIndex={draggingIndex}
                    dragOverIndex={dragOverIndex}
                    index={nextIndex}
                    userProfile={userProfile}
                    item={item}
                    editMode={editMode}
                    toggleModal={toggleModal}
                    openModal={openModal}
                  />
                )
              })}
            </div>
          )

          index += 2
        } else {
          if (editMode) {
            newRows.push(
              <span
                key={`add-after-half-${index}`}
                className={`${style.addComponentButton} ${style.addComponentButton_horizontal}`}
              >
                +
              </span>
            )
          }

          newRows.push(
            <LayoutItem
              key={index}
              handleDragStart={handleDragStart}
              handleDragOver={handleDragOver}
              handleDrop={handleDrop}
              handleDragEnd={handleDragEnd}
              draggingIndex={draggingIndex}
              dragOverIndex={dragOverIndex}
              index={index}
              userProfile={userProfile}
              item={current}
              editMode={editMode}
              toggleModal={toggleModal}
              openModal={openModal}
            />
          )
          index += 1
        }
      } else {
        if (editMode) {
          newRows.push(
            <span
              key={`add-after-half-${index}`}
              className={`${style.addComponentButton} ${style.addComponentButton_horizontal}`}
            >
              +
            </span>
          )
        }

        newRows.push(
          <LayoutItem
            key={index}
            handleDragStart={handleDragStart}
            handleDragOver={handleDragOver}
            handleDrop={handleDrop}
            handleDragEnd={handleDragEnd}
            draggingIndex={draggingIndex}
            dragOverIndex={dragOverIndex}
            index={index}
            userProfile={userProfile}
            item={current}
            editMode={editMode}
            toggleModal={toggleModal}
            openModal={openModal}
          />
        )
        index += 1
      }
    }

    if (editMode) {
      newRows.push(
        <span
          key="add-end"
          className={`${style.addComponentButton} ${style.addComponentButton_horizontal}`}
        >
          +
        </span>
      )
    }

    setRows(newRows)
  }, [
    layout,
    editMode,
    toggleModal,
    openModal,
    userProfile,
    dragOverIndex,
    draggingIndex,
  ])

  const handleDragStart = (index) => {
    setDraggingIndex(index)
  }

  const handleDragOver = (index) => {
    if (draggingIndex === null) return
    setDragOverIndex(index)
  }

  const handleDrop = (index) => {
    console.log('Dragging:', draggingIndex, ' Dropping at:', index)
    if (draggingIndex === null) return

    const updatedComponents = [...layout]
    const [draggedComponent] = updatedComponents.splice(draggingIndex, 1)
    updatedComponents.splice(index, 0, draggedComponent)

    updatedComponents[index].type = 'half'
    if (index + 1 < updatedComponents.length) {
      updatedComponents[index + 1].type = 'half'
    }

    setLayout(updatedComponents)
    saveLayout(updatedComponents, userProfile.user.user_id)
    setDraggingIndex(null)
    setDragOverIndex(null)
  }

  const handleDragEnd = () => {
    setDraggingIndex(null)
    setDragOverIndex(null)
  }

  return <div className={style.gridContainer}>{rows}</div>
}

export default ProfileLayout
